import React, { useState } from 'react';
import { chatGameApi } from './chatGameApi';

// 🛡️ Community report flag (MODERATION_P1_SPEC_2026_07_13.md).
// 🚩 → inline confirm (5s) → "✓ Reported". Never a bare one-tap: accidental
// reports would poison the 3-distinct-reporters threshold. Per-target
// reported state persists in localStorage so the flag never re-shows.
// The send half is shared: GhostLineMenu (a ghost line's ⋯) files the same report.

// Deep mounts (chat rows) don't thread gameId — the URL always has it on
// space pages. playerId may be null too: the server files those reports
// under a hashed IP identity.
const reportGameId = (gameId) => gameId || (() => {
  try {
    const u = new URL(window.location.href);
    return u.searchParams.get('gameId') || (u.pathname.match(/\/(?:space|s)\/([^/]+)/) || [])[1] || null;
  } catch (e) { return null; }
})();
const reportedKey = (targetId) => `reported:${targetId}`;
export const wasReported = (targetId) => {
  try { return !!localStorage.getItem(reportedKey(targetId)); } catch (e) { return false; }
};
export async function sendReport({ gameId = null, playerId = null, kind, targetId, targetPlayerId = null }) {
  await chatGameApi.submitContentReport(reportGameId(gameId), playerId, kind, targetId, targetPlayerId);
  try { localStorage.setItem(reportedKey(targetId), '1'); } catch (e) { /* private mode */ }
}

const ReportFlag = ({ gameId = null, playerId = null, kind, targetId, targetPlayerId = null, compact = false }) => {
  const [state, setState] = useState(() => (wasReported(targetId) ? 'done' : 'idle'));

  if (!targetId) return null;

  const send = async () => {
    setState('sending');
    try {
      await sendReport({ gameId, playerId, kind, targetId, targetPlayerId });
      setState('done');
    } catch (err) {
      console.error('[ReportFlag] Report failed:', err.message);
      setState('idle');
    }
  };

  const base = {
    border: 'none', borderRadius: 999, cursor: 'pointer',
    fontSize: compact ? '0.68em' : '0.75em', fontWeight: 700,
    // compact keeps the small type but not a sub-28px tap target (audit 07-15)
    padding: compact ? '6px 9px' : '4px 10px',
    background: 'rgba(0,0,0,0.55)', color: 'rgba(255,255,255,0.85)',
    whiteSpace: 'nowrap', flexShrink: 0,
  };

  if (state === 'done') {
    return <span style={{ ...base, cursor: 'default', opacity: 0.7 }}>✓ Reported</span>;
  }
  if (state === 'confirm' || state === 'sending') {
    return (
      <span style={{ display: 'inline-flex', gap: 4, flexShrink: 0 }}>
        <button
          onClick={(e) => { e.stopPropagation(); send(); }}
          disabled={state === 'sending'}
          style={{ ...base, background: 'rgba(220,38,38,0.9)', color: '#fff' }}
        >
          {state === 'sending' ? '…' : 'Yes, report'}
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); setState('idle'); }}
          style={base}
        >
          Cancel
        </button>
      </span>
    );
  }
  return (
    <button
      title="Report this"
      aria-label="Report this content"
      onClick={(e) => {
        e.stopPropagation();
        setState('confirm');
        setTimeout(() => setState((s) => (s === 'confirm' ? 'idle' : s)), 5000);
      }}
      style={base}
    >
      🚩
    </button>
  );
};

export default ReportFlag;
